import { StudyDetailsResponse } from "helpers/api";
import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from "react";

type DetailContentType = {
  studyDetails: StudyDetailsResponse | null;
};

const DetailContentContext = createContext<
  [DetailContentType, (value: DetailContentType) => void]
>([{ studyDetails: null }, () => {}]);

export const DetailContentContextProvider = (props: {
  children: ReactNode;
}) => {
  const [state, setState] = useState<DetailContentType>({ studyDetails: null });

  const setDetailContent = useCallback((value: DetailContentType) => {
    setState((prev) => ({ ...prev, ...value }));
  }, []);

  return (
    <DetailContentContext.Provider value={[state, setDetailContent]}>
      {props.children}
    </DetailContentContext.Provider>
  );
};

export const useDetailContent = () => {
  return useContext(DetailContentContext);
};
